import React, { ReactElement } from 'react';
import { Row, Alert } from '@dexma/ui-components';

import StyledGrid from 'adapter/in/dashboards/pages/Dashboard/style';
import DashboardPageHeaderContainer from 'adapter/in/dashboards/containers/Dashboard/Header';
import Dashboard from 'domain/entity/dashboard';
import withLoading, { ViewState } from 'adapter/in/common/hoc/withLoading';
import GridContainer from 'adapter/in/dashboards/containers/Grid';
import EmptyDashboardPage from 'adapter/in/dashboards/pages/Dashboard/EmptyDashboardPage';
import { StyledAnimationDiv } from 'adapter/in/common/style';
import { ALERT_ACTION_TYPE } from 'adapter/in/common/context/Alert';

export type DashboardPageProps = ViewState<Dashboard> & {
    onFullscreen: () => void;
    fullscreenActive: boolean;
    hasWidgets: boolean;
    alertMessage: string;
    alertType: ALERT_ACTION_TYPE;
    animationStyle: React.CSSProperties;
    showAlert: boolean;
};

export const DashboardPage = (props: DashboardPageProps): ReactElement => {
    const { data: dashboard, onFullscreen, fullscreenActive, hasWidgets, alertMessage, alertType, animationStyle, showAlert } = props;

    return (
        <StyledGrid fluid data-testid='dashboard' showAlert={showAlert}>
            <StyledAnimationDiv animationStyle={animationStyle}>
                <Alert description={alertMessage} type={alertType} showIcon />
                <DashboardPageHeaderContainer dashboard={dashboard} onFullscreen={onFullscreen} fullscreenActive={fullscreenActive} />
                <Row className='layout'>
                    {hasWidgets ? (
                        <GridContainer isEditEnabled={false} dashboardId={dashboard.id} editingLayout={false} />
                    ) : (
                        <EmptyDashboardPage />
                    )}
                </Row>
            </StyledAnimationDiv>
        </StyledGrid>
    );
};

export default withLoading(DashboardPage);
